module.exports = __webpack_public_path__ + "static/media/g-bg.5e8cdef4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/g-bg.svg
// module id = 455
// module chunks = 0